import { ref } from 'constants/firebase'
import { receivePlans, updatePlan, removePlan } from 'actions/plansAC'
import * as _ from 'lodash'

export function fetchPlans () {
  return function * (dispatch) {
    const plansSN = yield ref.child('plans').once('value')
    const plans = plansSN.val()
    // console.log('receivePlans', plans)
    if (plans) dispatch(receivePlans(plans))

    ref.child('plans')
      .orderByChild('timestamp')
      .startAt(_.now())
      .on('child_added', function (snapshot, prevChildKey) {
        dispatch(updatePlan(snapshot.key, snapshot.val()))
      })

    ref.child('plans').on('child_changed', function (snapshot, prevChildKey) {
      dispatch(updatePlan(snapshot.key, snapshot.val()))
    })

    ref.child('plans').on('child_removed', function (snapshot) {
      dispatch(removePlan(snapshot.key))
    })
  }
}



// WEBPACK FOOTER //
// ./src/controllers/plans.js